import { render, staticRenderFns } from "./Bot.vue?vue&type=template&id=7e5085d9&scoped=true&"
import script from "./Bot.vue?vue&type=script&lang=js&"
export * from "./Bot.vue?vue&type=script&lang=js&"
import style0 from "./Bot.vue?vue&type=style&index=0&id=7e5085d9&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e5085d9",
  null
  
)

export default component.exports